export enum SupportStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  FINISHED = "finished",
  CANCELED = "canceled",
}

export interface Support {
  id: number;
  title: string;
  description: string;
  status: SupportStatus;
  user_id: number;
  created_at: string;
  updated_at: string;
}

export interface CreateSupportPayload {
  title: string;
  description: string;
}

export interface UpdateSupportPayload {
  title?: string;
  description?: string;
  status?: SupportStatus;
  user_id?: number;
}

// Resposta do GET /supports/summary — sempre com as 4 chaves (zeradas se vazio).
export interface SupportSummary {
  pending: number;
  in_progress: number;
  finished: number;
  canceled: number;
}
